var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"bio-progress"},[_c('div',{staticClass:"bio-progress-bar",class:{ 'bio-progress-bar-warning': _vm.warning },style:(_vm.barSize)})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }